import { Component } from '@angular/core';

@Component({
  selector: 'app-social-band',
  templateUrl: './social-band.component.html',
  styleUrls: ['./social-band.component.scss'],
})
export class SocialBandComponent { }
